<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :custom-label="labelSelect"
    :options="options"
    selectLabel=""
    selectedLabel=""
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="false"
    :label="$t('Nome')"
    track-by="value"
    :disabled="isDisabled"
    placeholder=""
  >
  </multiselect>
</template>

<script>
export default {
  props: ['nameField', 'isDisabled'],
  data() {
    return {
      selected: 'vertical',
      options: [
        { value: 'vertical', text: this.$i18n.t('Vertical') },
        { value: 'horizontal', text: this.$i18n.t('Horizontal') }
      ]
    };
  },
  watch: {
    nameField(value) {
      this.setValue(value);
    }
  },
  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'orientacao_menu', null);
        return;
      }
      this.$emit('selectChange', 'orientacao_menu', e.value);

      this.$emit('focus');
    },
    labelSelect({ text }) {
      return `${text}`;
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => String(option.value) === String(value));
      } else {
        this.selected = this.options.find((option) => option.value === null);
      }
      this.$emit('input', this.selected);
    }
  },

  created() {
    this.setValue(this.nameField);
  }
};
</script>

<style lang="scss" scoped></style>
